import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'gigaPixels',
})
export class GigaPixelsPipe implements PipeTransform {
  transform(value: number | null): string {
    return value !== null ? `${Math.round(value / 1000_000_000)} GPx` : 'N/A';
  }
}
